import { useTranslator as useTranslatorBase } from '@digital-you/dy-warehouse/hooks'
import type { TypeDictionaryKeynames } from '@/app/dictionaries'

export const useTranslator = () => useTranslatorBase<TypeDictionaryKeynames>()
export { 
	useDeviceType,
	useMount,
	useScrollTracker,
} from '@digital-you/dy-warehouse/hooks'

// Usually cross-project hooks are exported here
export * from './base'
// Specific project hooks are exported here
export * from './project'
